
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import StockReport from 'app/views/Inventory/stock-report/stock-report'

// const ArticleLegder = Loadable(lazy(() => import('./article-legder/article-legder')));
const WmsInventoryRoutes = [


    {
        path: '/inventory/StockReport',
        element: <StockReport />
    },


];
export default WmsInventoryRoutes;